import React, { useState, useEffect } from "react";
import axios from "axios";
import { useRecoilState } from "recoil";
import { settedFileAtom } from "../atoms/settedFileAtom";

const FileTreeNew = ({
  id,
  socket,
  roomName,
}: {
  id: any;
  socket: any;
  roomName: any;
}) => {
  const [fileTree, setFileTree] = useState<any>([]);
  const [branch1, setBranch1] = useState<any>("");
  const [branch2, setBranch2] = useState<any>("");
  const [fileList, setFileList] = useState<any>([]);
  const [isChecked, setIsChecked] = useState<any>([]);
  const [selectedFile, setSelectedFile] = useState<any>([]);
  const [settedFile, setSettedFile] = useRecoilState(settedFileAtom);

  const onBranch1Change = (e: any) => {
    setBranch1(e.target.value);
    console.log("첫번째 가지", e.target.value);
  };
  const onBranch2Change = async (e: any) => {
    setBranch2(e.target.value);
    const target: any = (fileTree as any)[branch1][(e.target as any).value];
    setFileList([]);
    if (Object.keys(target).length === 0) return;
    const keys = Object.keys(target);
    const tmp = target[keys[0]];
    const values = tmp.value.split("|");
    const config = values.slice(0, 3).join("|");
    const res = await axios.get(
      `https://chamstudyland.com/vokok/lib/get_word_count.php`,
      {
        params: {
          config: config,
          user_id: id,
        },
      }
    );
    const fileObj = [];
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      fileObj.push({
        name: target[key].name,
        value: target[key].value,
        count: res.data[i],
      });
    }
    setFileList(fileObj);
    console.log("이거다 파일 데이터", fileObj);
    console.log("정렬 데이터", fileObj[0].value);
    setSettedFile(fileObj[0].value);
    console.log("세트파일아톰에 저장된 데이터", settedFile);
    const tmpChecked = new Array(fileObj.length).fill(false);
    setIsChecked(tmpChecked);
  };
  const onChkBoxChange = (idx: any) => {
    const newObj = [...isChecked];
    newObj[idx] = !newObj[idx];
    setIsChecked(newObj);
  };

  useEffect(() => {
    if (!fileList) return;
    const selList = [];
    for (let i = 0; i < fileList.length; i++) {
      if (isChecked[i])
        selList.push({ ...fileList[i], folderName: `${branch1}_${branch2}` });
    }
    setSelectedFile(selList);
  }, [isChecked]);

  useEffect(() => {
    socket.emit("study_sel", roomName, selectedFile);
  }, [selectedFile]);

  const getFileTreeData = async () => {
    const res = await axios.get(
      `https://chamstudyland.com/vokok/lib/get_file_tree.php`,
      {
        params: {
          user_id: id,
        },
      }
    );
    setFileTree(res.data);
  };

  useEffect(() => {
    getFileTreeData();
  }, []);

  return (
    <div className="mainContainer flex flex-col md:flex-row p-4 gap-4 dark:bg-gray-900 bg-white text-gray-900 dark:text-gray-100">
      <select
        className="h-10 p-2 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700"
        value={branch1}
        onChange={onBranch1Change}
      >
        <option value="">대분류</option>
        {fileTree
          ? Object.keys(fileTree).map((folderName, idx) => {
              return (
                <option key={idx} value={folderName}>
                  {folderName}
                </option>
              );
            })
          : ""}
      </select>
      <select
        className="h-10 p-2 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700"
        value={branch2}
        onChange={onBranch2Change}
      >
        <option value="">중분류</option>
        {fileTree && branch1 !== ""
          ? Object.keys(fileTree[branch1]).map((folderName, idx) => {
              return (
                <option key={idx} value={folderName}>
                  {folderName}
                </option>
              );
            })
          : ""}
      </select>
      <div className="flex flex-col gap-2 mt-4 md:mt-0 h-64 overflow-y-auto">
        {fileTree && branch2 !== ""
          ? fileList.map((file: any, idx: any) => {
              return (
                <div key={idx} className="flex items-center gap-2">
                  <input
                    className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 dark:border-gray-600 dark:bg-gray-700"
                    type="checkbox"
                    id={`file-${file.name}`}
                    checked={isChecked[idx]}
                    onChange={(e) => onChkBoxChange(idx)}
                  />
                  <label
                    htmlFor={`file-${file.name}`}
                    className="cursor-pointer"
                  >
                    {file.name} ({file.count})
                  </label>
                </div>
              );
            })
          : ""}
      </div>
    </div>
  );
};

export default FileTreeNew;
